(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var findIndex = require('lodash.findindex')
  , find = require('lodash.find')

module.exports = function () {
  return function (field, event, value) {
    var fieldName = field.toLowerCase()
      , embellishedFieldName = '__' + fieldName + 's'
      , selectize = this.$('.js-' + fieldName)[0].selectize
      , existing = this.model.get(embellishedFieldName) || []
      , option = selectize.options[value] || find(existing, { _id: value })
      , newValue
      , oldValue

    if (field !== 'Genre') {
      handleSelectChange.call(this)
    } else {
      if (event === 'add') {
        newValue = value
        oldValue = null
      } else if (event === 'delete') {
        oldValue = value
        newValue = null
      }
    }

    function handleSelectChange () {
      if (event === 'add') {
        existing.push(option)
        newValue = option.name
        oldValue = null
      } else if (event === 'delete') {
        var i = findIndex(existing, { _id: value })
        existing.splice(i, 1)
        newValue = null
        oldValue = option.name
      }
      this.model.set(embellishedFieldName, existing)
    }

    this.model.updateChangelog(
      { event: event
      , field: field
      , new: newValue
      , old: oldValue
      })
  }
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/festival/lib/select-change-delegate.js","/components/admin/festival/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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